  /* @flow strict */

import * as React from 'react';
import _ from 'lodash';
import { I18nextProvider } from 'react-i18next';
import { Switch, Route, Redirect } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import i18n from './i18n';

import { decrypt } from '/server/utils/encode';
import { encryptKey } from '/client/src/constants';
import DefaultContainer from './container/default';
import NotFound from './pages/NotFound';
import routes from './routes';
import ServiceMsg from './utils/serviceMsg';
import AuthPage from './pages/Auth';

import Auth from './modules/Auth';

type PropsType = {};
type StateType = {
  authenticated: boolean
};

const queryString = require('query-string');

class Entry extends React.Component<PropsType, StateType> {
  state: StateType;

  constructor(props: PropsType) {
    super(props);
    const isRedirectFromOldApp = _.get(queryString.parse(location.search), 'redirect-token', null);
    const isCollaboratorSignUpPage = _.get(queryString.parse(location.search), 'email', null) && _.get(queryString.parse(location.search), 'token', null);

    if (isRedirectFromOldApp) {
      const decriptedToken = decrypt(isRedirectFromOldApp, encryptKey);

      try {
        const _parsedString = JSON.parse(decriptedToken);

        window.localStorage.setItem('user', JSON.stringify({
          access_token: _parsedString.accessToken,
          token_type: 'jwt_bearer',
          expires_in: 31536000
        }));
      } catch (e) {
        window.location.search = '';

        console.error(e);
      }
    }
    if (isCollaboratorSignUpPage) {
      try {
        window.localStorage.removeItem('user');
      } catch (e) {
        window.location.search = '';
        console.error(e);
      }
   }
    this.state = {
      authenticated: !!isRedirectFromOldApp || Auth.isUserAuthenticated()
    };

    ServiceMsg();
  }

  toggleAuthenticateStatus = async () => {
    this.setState({ authenticated: Auth.isUserAuthenticated() });
  };

  logout = () => {
    if (Auth.isUserAuthenticated()) {
      window.localStorage.removeItem('user');
      this.setState({ authenticated: false });
    }
  };

  render = (): React.Element => {
    return (
      <I18nextProvider i18n={i18n}>
        <DefaultContainer
          isEmpty={!this.state.authenticated}
          toggleAuthenticateStatus={
            (): any => this.toggleAuthenticateStatus()
          }
        >
          <Switch>
            {routes.loggedOutRoutes(this.toggleAuthenticateStatus)}

            {routes.privatRoutes()}
            <Route path='/sign-up' render={(): any => <AuthPage logout={this.logout} />} />
            <Route
              path='/'
              exact
              render={(): any => (
                <Redirect to={{ pathname: '/events' }} />
              )}
            />

            <Route component={NotFound} />
          </Switch>
        </DefaultContainer>
        <ToastContainer />
      </I18nextProvider>
    );
  };
}

export default Entry;
